import { Reveal } from "@/components/Reveal";

export const Discretion = () => {
  return (
    <section
      className="bg-[#02515A] texture-teal py-32 md:py-44"
      data-testid="discretion-section"
    >
      <div className="max-w-6xl mx-auto px-6 md:px-12 grid md:grid-cols-12 gap-12 items-start">
        <Reveal className="md:col-span-5">
          <p className="text-xs tracking-[0.35em] uppercase text-[#E0A8C5] mb-8">
            Discretion
          </p>
          <h2 className="font-serif-display font-light text-4xl sm:text-5xl leading-tight text-[#FCF5EB]">
            A life lived in public
            <br />
            <span className="italic">deserves a goodbye held in private.</span>
          </h2>
        </Reveal>
        <Reveal delay={0.2} className="md:col-span-6 md:col-start-7">
          <p className="text-base md:text-lg font-light leading-loose text-[#FCF5EB]/85">
            Absolute confidentiality and discretion for high-profile individuals
            and their estates. Your name, your plans, and your people are
            protected at every step — nothing is shared, published, or
            spoken of beyond the room.
          </p>
          <p className="mt-8 text-base md:text-lg font-light leading-loose text-[#FCF5EB]/85">
            Inquiries are received personally and answered in confidence. You
            may be as involved, or as hands-off, as feels right.
          </p>
          <div className="mt-12 w-16 h-px bg-[#D9A441]" aria-hidden="true" />
        </Reveal>
      </div>
    </section>
  );
};
